export enum ChipPreset {
  DEFAULT = 'default',
  GREEN = 'green',
  ORANGE = 'orange',
  RED = 'red',
  GREY = 'grey',
}
